/**
 * @copyright Copyright (c) 2015, Pacific Biosciences of California, Inc.
 * @author <a href="mailto:bskinner@pacificbiosciences.com">Brian Skinner</a>
 */

import {Facet} from "../facets/facet"
import {REFERENCE_FRAME} from "../frames/reference"
import { multisort, desc, valueToDate } from "../../core/utils/property-sort"

export const REFERENCE_FACET = new Facet({
    frame: REFERENCE_FRAME,
    multiSelect: true,
    defaultColumns: [
        "id", "name", "numRecords", "totalLength", "organism", "ploidy", "createdAt", "updatedAt"],
    initialSort: multisort(desc(valueToDate("updatedAt")), desc(valueToDate("createdAt"))),
    additionalColumns: [
        "uuid", "path", "tags", "projectId", "version", "md5", "createdBy", "comments"],
    displayProperties: [
        "name", "organism", "ploidy", "totalLength", "numRecords",
        "createdAt", "updatedAt", "id", "uuid", "path",
        "tags", "projectId", "version", "md5", "createdBy", "comments"]
})
